var elementHasFocus = function elementHasFocus(element) {
  return document.activeElement === element;
};

export default elementHasFocus;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/utils/dist/esm/elementHasFocus/index.js
// module id = 1041
// module chunks = 12